import { render, staticRenderFns } from "./Etabs.vue?vue&type=template&id=3214a7f2&"
import script from "./Etabs.vue?vue&type=script&lang=js&"
export * from "./Etabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports